import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageSize: 15,
  currentPage: 1,
  url: `/organizationlist/`,
  filter_flag: false,
  search: "",
  filters: "",
  itemsLength: 0,
  activeRedux: true,
  sort_column: "",
  sort_order: "",
  newPageSize: 15,
  //   loadingRedux: true,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterDataRedux: (state, action) => {
      const {
        pageSize,
        currentPage,
        url,
        filter_flag,
        search,
        filters,
        itemsLength,
        activeRedux,
        sort_column,
        sort_order,
        newPageSize,
      } = action.payload;

      // Update state with new filter values
      state.pageSize = pageSize;
      state.currentPage = currentPage;
      state.url = url;
      state.filter_flag = filter_flag;
      state.search = search;
      state.filters = filters;
      state.activeRedux = activeRedux;
      state.sort_column = sort_column;
      state.sort_order = sort_order;
      state.newPageSize = newPageSize;
      // Update items length
      state.itemsLength =
        itemsLength !== undefined ? itemsLength : state.itemsLength;
    },
  },
});

export const { setFilterDataRedux } = filterSlice.actions;
export default filterSlice.reducer;
